import { Checkbox, NavLink } from '@mantine/core';
import { useStoreMap, useUnit } from 'effector-react';
import { PlusSquare, MinusSquare } from 'lucide-react';
import { accountTreeModel } from '../../model';
import cls from './account-tree-item.module.scss';

type AccountTreeItemProps = {
	id: number;
};

export const AccountTreeItem = ({ id }: AccountTreeItemProps) => {
	const item = useStoreMap({
		keys: [id],
		store: accountTreeModel.$nodes,
		fn: (nodes, [nodeId]) => nodes[nodeId],
	});

	const isSelected = useStoreMap({
		keys: [id],
		store: accountTreeModel.$selectedNodes,
		fn: (nodes, [nodeId]) => nodes.includes(nodeId),
	});

	const [setSelectedNodes, selectNode, deselectNode, expandNode, collapseNode] = useUnit([
		accountTreeModel.setSelectedNodes,
		accountTreeModel.selectNode,
		accountTreeModel.deselectNode,
		accountTreeModel.expandNode,
		accountTreeModel.collapseNode,
	]);

	const isHaveChild = item.childrenIds.length > 0;

	const rightIcon = item.opened ? (
		<MinusSquare
			data-test-id={`account-tree-item-collapse-${item.id}`}
			className={cls.accountTreeItemIcon}
			onClick={(e) => {
				e.stopPropagation();
				collapseNode(item.id);
			}}
		/>
	) : (
		<PlusSquare
			data-test-id={`account-tree-item-expand-${item.id}`}
			className={cls.accountTreeItemIcon}
			onClick={(e) => {
				e.stopPropagation();
				expandNode(item.id);
			}}
		/>
	);

	return (
		<NavLink
			data-root={item.parentId === null || undefined}
			data-test-id={`account-tree-item-${item.id}`}
			label={item.value.name}
			component='div'
			classNames={{
				root: cls.accountTreeItemRoot,
				label: cls.accountTreeItemRootLabel,
				children: cls.accountTreeItemRootChildren,
			}}
			leftSection={
				<Checkbox
					readOnly
					data-test-id={`account-tree-item-checkbox-${item.id}`}
					tabIndex={-1}
					className={cls.accountTreeItemCheckbox}
					checked={isSelected}
					wrapperProps={{
						onClick: (e) => {
							e.stopPropagation();

							isSelected ? deselectNode(item.id) : selectNode(item.id);
						},
					}}
				/>
			}
			rightSection={isHaveChild && rightIcon}
			opened={item.opened}
			onClick={() => setSelectedNodes([id])}
		>
			{item.childrenIds.map((childId) => (
				<AccountTreeItem
					key={childId}
					id={childId}
				/>
			))}
		</NavLink>
	);
};
